export default __webpack_public_path__ + "static/media/letter.35c3d9d9.svg";